import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class DialogService{

  private openDialog = new Subject();
  openDialog$ = this.openDialog.asObservable();
  showWhiteDialog = false;

  private dialogAction = new Subject();
  dialogAction$ = this.dialogAction.asObservable();

  DIALOG_STR = {
    NOT_FOUND: 'Please try taking the picture again.' +
      'We suggest keeping the full page in view, and take it with as steady hand as possible.',
    SCAN_CLOSELY: 'Please scan the image closely so that the words appear clearly',
    WENT_WRONG: 'Something went wrong. Please try again later',
    TIME_OUT: 'Your internet connection must be 1.5MB or faster.' +
      'Please try again when you have a faster internet connection',
    SCAN_PROGRESS: 'Finding matching content for this page',
    NETWORK: 'Please check your network connection.'
  };

  dialogProperties = {
    title: 'Scan Info',
    type: 'alert',
    additionalInfo: '',
    body: 'Not Found', buttons: {ok: 'Cancel', cancel: ''}
  };


  showDialog(BODY_STR): void{
    this.dialogProperties.additionalInfo = (BODY_STR === 'TIME_OUT') ? 'Please try again when you have a faster internet connection' : '';
    switch (BODY_STR) {
      case 'NOT_FOUND':
        this.dialogProperties.title = 'Matching content not found';
        this.showWhiteDialog = true;
        break;
      case 'SCAN_PROGRESS':
        this.showWhiteDialog = false;
        this.dialogProperties.title = 'Please wait';
        break;
      case 'TIME_OUT':
        this.dialogProperties.title = 'Could not find the resource in time';
        this.showWhiteDialog = true;
        break;
      default:
        this.dialogProperties.title = 'Scan Info';
        this.showWhiteDialog = false;
    }
    this.dialogProperties.body = this.DIALOG_STR[BODY_STR];
    this.openDialog.next(true);
  }

  hideDialog(): void{
    this.openDialog.next(false);
    this.dialogProperties = {
      title: 'Image Details',
      type: 'alert',
      additionalInfo: '',
      body: 'Not Found', buttons: {ok: 'Close', cancel: ''}
    };
  }

  dialogClickAction(value: boolean): void{
    this.dialogAction.next(value);
  }
}
